<template>
  <v-my-layout>
    <template slot="nav">
      <v-device-drawer
        :devices="formattedDevices"
      />
    </template>
    <div slot="body">
      <div
        v-if="focusedDevice"
        class="machine"
        :class="$vuetify.breakpoint.smAndDown ? 'px-1 py-1' : 'px-5 py-3'"
      >
        <v-machine
          :key="focusedDevice.id"
          :machine="focusedDevice"
        />
      </div>

      <v-speed-dial
        bottom
        right
        fixed
      >
        <template v-slot:activator>
          <v-btn
            color="#6480C9"
            dark
            fab
            class="mb-2"
            @click.stop="reload"
          >
            <v-icon :style="{lineHeight: '58px'}">
              refresh
            </v-icon>
          </v-btn>
        </template>
      </v-speed-dial>
    </div>
  </v-my-layout>
</template>

<script>
import VMyLayout from '@/layouts/Default.vue';
import VMachine from '@/components/Machine.vue';
import VDeviceDrawer from '@/components/DeviceDrawer.vue';
import gql from 'graphql-tag';

export default {
  name: 'HomeIndex',

  components: {
    VMyLayout,
    VDeviceDrawer,
    VMachine,
  },

  data() {
    return {
      loaded: false,
      devices: [],
      timeSpan: '1d',
    };
  },

  computed: {
    focusedDevice() {
      if (this.$route.params.id) {
        return this.devices.find(d => d.id === this.$route.params.id);
      }
      return this.devices[0];
    },
    formattedDevices() {
      return this.devices.map(device => ({
        ...device,
        route: {
          name: 'home.index',
          params: {
            id: device.id,
          },
        },
      }));
    },
  },

  methods: {
    reload() {
      window.location.reload();
    },
    setActiveTab() {
      if (!this.$route.params.id) {
        const firstDevice = this.formattedDevices[0];
        this.$router.push(firstDevice.route);
      }
    },
  },

  apollo: {
    devices: {
      query: gql`{
        device {
          group {
            devices {
              authorized
              id
              key
              name
            }
          }
          id
          key
          name
        }
      }`,
      update: data => data.device,
      result() {
        this.setActiveTab();
      },
    },
  },
};
</script>
